import axios, { AxiosResponse } from 'axios';
import { optimizeMediaUrls } from './imageOptimizer';

const getService = ()=>{
  if (process.env.NODE_ENV == "development") {
    return "/api"
  } else {
    const origin = window.location.origin
    return origin + "/api"
  }
}
export const service_ip =getService();



export const fetch = (
  params,
) => {
  return new Promise((resolve, reject) => {
    params.url = `${service_ip}${params.url}`;
    const method = params.method || 'post'
    const data = method == 'post' ? params.data : params.data;
    console.log(data)
      axios({
        ...params,
        method: method,
        data: data,
        params: method == 'get' ? data : {},
        withCredentials: true,
        timeout:10000
      })
        .then((res) => {
          if (typeof res == 'string') {
            res = JSON.parse(res);
          }

          const rResult = res.data;
          if (rResult && rResult.result == 1) {
            // 自动优化返回数据中的图片和视频URL
            const optimizedData = optimizeMediaUrls(rResult.data, {
              imageWidth: params.imageWidth,
              imageHeight: params.imageHeight,
              imageQuality: params.imageQuality || 85,
              imageFormat: params.imageFormat || 'webp'
            });
            resolve(optimizedData);
          } else {
            reject(rResult.msg);
           
          }
        })
        .catch((error) => {
          if (error.code === 'ECONNABORTED') {
            return false;
          }
          reject(error);
        });
  });
};

/**
 * post参数处理
 */
export const paramsHandler = function (v) {
  var formData = new FormData()
  for (let i in v) {
    formData.append(i, v[i])
  }
  return formData;
};

export function menuDataTransfrom(data=[],props={labelKey:'name',childrenKey:'subs',key:'id'}) {
  const {labelKey,childrenKey} = props;
  return data.map(item => {
    return{
    label: item[labelKey],
    key: String(item[props.key]),
    children: item[childrenKey] ? menuDataTransfrom(item[childrenKey],props) : undefined,
    ...item
  }});
}
// 函数会递归遍历菜单数据
export const findOpenKeys = (menuItems=[], targetKey="", path= []) => {
  for (const item of menuItems) {
    // 如果当前项的 id 匹配目标 id，返回当前的路径
    if (item.key === targetKey) {
      return path;
    }

    // 如果当前项有子项，递归查找
    if (item.children) {
      const result = findOpenKeys(item.children, targetKey, [...path, item.key]);
      if (result) {
        return result;
      }
    }
  }

  // 如果没有找到，返回 null
  return null;
};
// 根据key值找对象
export const findMenuItemById = (menuItems=[], targetKey="")=> {
  for (const item of menuItems) {
    // 如果当前项的 id 匹配目标 id，返回当前项
    if (item.key === targetKey) {
      return item;
    }

    // 如果当前项有子项，递归查找
    if (item.children) {
      const result = findMenuItemById(item.children, targetKey);
      if (result) {
        return result;
      }
    }
  }

  // 如果没有找到，返回 null
  return null;
};

//错误码
export const msgCode = (n) => {
  if (n === undefined) {
    return '未知错误';
  }
  n = n.toString();
  switch (n) {
    case '100':
      return 'json解析错误';
    default:
      return '未知错误';
  }
};
/**
 * 判断链接是图片、视频还是未知类型
 * @param {string} url - 文件链接
 * @returns {'image' | 'video' | 'unknown'} 文件类型
 */
export function checkFileType(url) {
  if (!url) return 'unknown';
  
  // 常见图片扩展名
  const imageExtensions = [
    'jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 
    'svg', 'ico', 'tiff', 'tif', 'heic', 'heif'
  ];
  
  // 常见视频扩展名
  const videoExtensions = [
    'mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv',
    'webm', 'm4v', 'mpg', 'mpeg', '3gp', 'ogg'
  ];
  
  // 提取扩展名（不区分大小写）
  const extension = url.split('.').pop().toLowerCase().split('?')[0].split('#')[0];
  
  if (imageExtensions.includes(extension)) {
    return 'image';
  } else if (videoExtensions.includes(extension)) {
    return 'video';
  } else {
    return 'unknown';
  }
}
